import style from './StageQualityStartModal.module.css';

import { PUBLIC_ASSETS, address_server_short } from 'config';
import { useEffect, useState } from 'react';
import { getDevicesByDeviceModelId } from 'services/device.services';
import FormSelect from 'ui/formItems/FormSelect';
import Icon from 'ui/Icon';

const Model = ({ model, index }) => {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    const load = async () => {
      const { data } = await getDevicesByDeviceModelId(model.id);
      setDevices(data);
    };
    load();
  }, []);

  return (
    <div className={style.resourceContainer}>
      <div className={style.wrapperDeviceModel}>
        <div className={style.deviceModel}>{model?.name}</div>
        <FormSelect
          name={`params.devices.[${index}]`}
          options={devices}
          hideErrorBlock
          renderOption={({ option }) => (
            <div className={style.itemSelect}>
              <Icon
                width={30}
                height={30}
                src={address_server_short + PUBLIC_ASSETS + model.image}
                alt="оборудование"
              />
              <span>
                {option.name} инв. {option?.inventory_number}
              </span>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default Model;
